import FormattedPropertyCurrencyV2 from './FormattedPropertyCurrencyV2';
import { useProperty } from '../hooks/useProperty';
import { getCurrencyCodeForPriceProperty } from 'customer-data-objects/lineItem/PropertyNames';
import useComponentMountMetric from '../../metrics/useComponentMountMetric';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedPropertyPrice = props => {
  useComponentMountMetric('FormattedPropertyPrice');
  const property = useProperty();
  const currencyCode = getCurrencyCodeForPriceProperty(property.name);
  let {
    currencyProps
  } = props;
  // Override currency code if one is has not been provided
  if (currencyCode && (!currencyProps || !currencyProps.currencyCode)) {
    currencyProps = Object.assign({}, props.currencyProps, {
      currencyCode
    });
  }
  return /*#__PURE__*/_jsx(FormattedPropertyCurrencyV2, Object.assign({}, props, {
    currencyProps: currencyProps
  }));
};
export default FormattedPropertyPrice;